import User from '../../models/User';
import { isUserAdmin } from '../../businessLogicService/isUserAdmin';
import { ADMIN_NAV_CATEGORIES, PageCategory, TEACHER_NAV_CATEGORIES } from './pageCategories';

export interface SideNavItem extends PageCategory {
  id: string;
}

const idFor = (label: string) => `sideNav${label.replace(/[^A-Za-z]/g, '')}`;

export const getSideNavItems = (user: User): SideNavItem[] =>
  (isUserAdmin(user) ? ADMIN_NAV_CATEGORIES : TEACHER_NAV_CATEGORIES).map(category => ({
    id: category.navId ?? idFor(category.label),
    ...category,
  }));
